import type { Route } from 'next';

export interface FaqTagListProps {
  items: Array<{
    child: React.ReactNode;
    href?: Route;
  }>;
  FaqTagListComponent: React.ComponentType<{
    items: Array<{
      child: React.ReactNode;
      href?: Route;
    }>;
  }>;
}

function FaqTagList({ items, FaqTagListComponent }: FaqTagListProps) {
  return <FaqTagListComponent items={items} />;
}

export default FaqTagList;
